export class PhoneNumber {
  questionNo: number;

  choiceNo = 1;

  constructor() {
  }

}
